import {TicketFormField} from "./TicketFormField";

export class WorklogSimple extends TicketFormField {
	public contractResourceUsageUrl : string;

	afterIndex() {
		super.afterIndex();
		if (this.ui.customerId) {
			//todo: vyhodit jquery
			this.ui.customerId.selectize.on('change', value =>
				// @ts-ignore
				$(this.ui.customerInfo).load(this.getContractResourceUsageUrl("", value.substr(1)))
			);
		}
	}

	getContractResourceUsageUrl(contractId, customerId)
	{
		return this.contractResourceUsageUrl.replace('__contractId__', contractId).replace('__customerId__', customerId);
	}
}
